import { Route, Switch } from "react-router";
import FillupsTable from "./FillupsTable";
import FillupsForm from "./FillupsForm";
import WriteRoute from "../../shared/components/WriteRoute";

export default () => (
  <Switch>
    <Route exact path="/fillups" component={FillupsTable} />
    <WriteRoute
      exact
      path="/fillups/addnew"
      component={FillupsForm}
      redirectTo="/fillups"
    />
  </Switch>
);
